import React from "react";
export var ClipPath = function (props) {
  var _props$clipId;

  return /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: (_props$clipId = props.clipId) === null || _props$clipId === void 0 ? void 0 : _props$clipId.toString()
  }, props.children));
};